import React from 'react';
import Accordion from '@common/ui/accordion/Accordion';
import AccordionItem from '@common/ui/accordion/AccordionItem';
import classNames from 'classnames';
import { t } from 'i18next';
const ClientSrviceFAQSAccordion = (props) => {
    var _a;
    const getHtmlContent = (str) => {
        return React.createElement("div", { dangerouslySetInnerHTML: { __html: str } });
    };
    return (React.createElement("div", { className: classNames(props.className, 'cs-faqs__accordiongroup', { 'no-divider': !props.divider }) },
        React.createElement(Accordion, { type: "ul" }, (_a = props.faqs) === null || _a === void 0 ? void 0 : _a.map((f, i) => (React.createElement(AccordionItem, { key: f.title, title: getHtmlContent(f.title), accordionId: f.title, itemClass: "faq--card", headerClass: "accordion__header--lc" },
            React.createElement("div", { className: "faq--card-body" }, getHtmlContent(f.content)))))),
        props.viewallurl && (React.createElement("div", null,
            React.createElement("a", { href: props.viewallurl, className: "button button--tertiary" }, t('button.viewall'))))));
};
ClientSrviceFAQSAccordion.defaultProps = {
    divider: true,
};
export default ClientSrviceFAQSAccordion;
